import { colors } from 'parameters/ui'
import { Ref, useEffect, useRef } from 'react'
import { primaryColorGeneratorFactory } from './utils'

interface RangeHookReturn {
	inputRef: Ref<HTMLInputElement>
}

export const useRange = (
	value: number,
	backgroundGenerator = primaryColorGeneratorFactory(colors.primaryGreen1)
): RangeHookReturn => {
	const inputRef = useRef<HTMLInputElement>(null)
	useEffect(() => {
		if (inputRef.current) {
			const range = inputRef.current
			const min = range.min ? Number(range.min) : 0
			const max = range.max ? Number(range.max) : 100
			const percent = ((value - min) / (max - min)) * 100
			range.style.background = backgroundGenerator(percent)
		}
	}, [value, backgroundGenerator])

	return { inputRef }
}
